module.exports = __webpack_public_path__ + "img/ep3-8.0398dc5c.jpeg";